import http from "./httpService";
import { config } from "../config";
import { getIdentity } from "../components/common/commonFuncs";
import { preloadQAFormEndpoint } from '../constants/QuestionTypes'

////////////////////////////////////////////////////////////////
const prefix = '/api/v2/forms/';
const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////

export function removeWidget(Widget_ID) {
	return http.post(apiEndpoint + prefix + 'removeWidget', {
		Widget_ID: Widget_ID,
		Activity_By: getIdentity(),
	});
}

export function getForms() {
	return http.get(apiEndpoint + prefix + 'getForms', { params: { Activity_By: getIdentity() } });
}

export function getForm(Form_ID) {
	return http.post(apiEndpoint + prefix + 'getForm', {
		Form_ID : Form_ID,
		Activity_By: getIdentity()
	});
}

export function getQuestionTypes() {
	return http.get(apiEndpoint + prefix + 'widgetQA', { params: { Activity_By: getIdentity() } });
}

export function getWidgetTypes() {
	return http.get(apiEndpoint + prefix + 'widgetTypes', { params: { Activity_By: getIdentity() } });
}

export function getFormWidgetQuestionsAnswers(Form_ID) {
	return http.post(apiEndpoint + prefix + 'getFormWidgetQuestionsAnswers', {
		Form_ID: Form_ID,
		Activity_By: getIdentity()
	})
}

export function getInfoConfigShared(Form_ID) {
	return http.post(apiEndpoint + prefix + 'getInfoConfigShared', {
		Form_ID: Form_ID,
		Activity_By: getIdentity()
	})
}

export function getTabForms(Project_ID) {
	return http.get(apiEndpoint + prefix + 'widgetTab', {
		params: {
			Project_ID,
			Activity_By: getIdentity(),
		},
	});
}

export function updateForm(Form_ID, Form_Name) {
	return http.post(apiEndpoint + prefix + 'saveForm', {
		Form_ID: Form_ID,
		Form_Name: Form_Name,
		Activity_By: getIdentity(),
	});
}

export function saveFormSettings(state){
	return http.post(apiEndpoint + prefix + 'saveFormSettings', {
		Form_ID: parseInt(state.Form_ID),
		Form_CustomValidationSP: state.Form_CustomValidationSP || null,
		Form_BehaviorOnSave: parseInt(state.Form_BehaviorOnSave) || null,
		Form_RedirectTo: parseInt(state.Form_RedirectTo) || null,
		Form_ClienstSideRules: (state.Form_ClienstSideRules).length >= 1 && (state.Form_ClienstSideRules)[0]['Rule_Text'] !== '' ? state.Form_ClienstSideRules : null,
		Form_SaveButton_disable: state.Form_SaveButton || null,
		Form_CancelButton_disable: state.Form_CancelButton || null,
		Activity_By: getIdentity(),
	});
}


export function customValidateForm(Form_ID, PrimaryKey, saveResponse, Form_CustomValidationSP, SecondaryKey){
	return http.post(apiEndpoint + prefix + 'customValidateForm', {
		Form_ID: parseInt(Form_ID) || 0,
		PrimaryKey: PrimaryKey || null,
		SecondaryKey : SecondaryKey || 0,
		toSave_Response : saveResponse,
		Form_CustomValidationSP: Form_CustomValidationSP || null,
		Activity_By: getIdentity(),
	});
}

export function getFormWidgets(Form_ID, AllWidgets = true) {
	return http.get(apiEndpoint + prefix + 'formWidgets', {
		params: {
			Form_ID: Form_ID,
			AllWidgets: AllWidgets,
			Activity_By: getIdentity()
		},
	});
}

export function getFormDataElements(Form_ID){
	return http.get(apiEndpoint + prefix + 'getFormDataElements', {
		params: {
			Form_ID: Form_ID,
			Activity_By: getIdentity()
		},
	});
}

export function updateQuestionOrder(Form_Widgets) {
	return http.post(apiEndpoint + prefix + 'updateOrder', {
		Form_Widgets: Form_Widgets,
		Activity_By: getIdentity(),
	});
}

export function saveFormWidget(Form_ID, Widget_Type_ID, Widget_Name) {
	return http.post(apiEndpoint + prefix + 'newFormWidget', {
		Form_ID: Form_ID,
		Widget_Type_ID: Widget_Type_ID,
		Widget_Name: Widget_Name,
		Activity_By: getIdentity(),
	});
}

export function getQualtrics(wID) {
	return http.get(apiEndpoint + prefix + 'getQualtrics', {
		params: {
			Widget_ID: wID,
			Activity_By: getIdentity()
		},
	});
}

export function updateQualtrics(qID, wID, Survey_ID, Display_Name) {
	return http.post(apiEndpoint + prefix + 'updateQualtrics', {
		Qualtrics_ID: qID,
		Widget_ID: wID,
		Survey_ID: Survey_ID,
		Display_Name: Display_Name,
		Activity_By: getIdentity(),
	});
}


export function getREDCapSurveyDetails(wID) {
	return http.get(apiEndpoint + prefix + 'getREDCapSurveyDetails', { params: { Widget_ID: wID } });
}

export function updateREDCapSurveyDetails(REDCap_ID, wID, Survey_ID, Display_Name) {
	return http.post(apiEndpoint + prefix + 'updateREDCapSurveyDetails', {
		REDCap_ID: REDCap_ID,
		Widget_ID: wID,
		Survey_ID: Survey_ID,
		Display_Name: Display_Name,
		Activity_By: getIdentity(),
	});
}

export function getTabs(wID) {
	return http.get(apiEndpoint + prefix + 'getTabs', {
		params: {
			Widget_ID: wID,
			Activity_By: getIdentity()
		},
	});
}

export function updateTab(wID, tabs) {
	return http.post(apiEndpoint + prefix + 'updateTabs', {
		Widget_ID: wID,
		Tabs: tabs,
		Activity_By: getIdentity(),
	});
}

export function removeTab(wID, tID) {
	return http.post(apiEndpoint + prefix + 'removeTabs', {
		Widget_ID: wID,
		Tab_ID: tID ? tID : null,
		Activity_By: getIdentity(),
	});
}

export function getQuestion(wID) {
	return http.get(apiEndpoint + prefix + 'getQuestion', {
		params: {
			Widget_ID: wID,
			Activity_By: getIdentity()
		},
	});
}

export function getAnswers(qID) {
	return http.get(apiEndpoint + prefix + 'getAnswers', {
		params: {
			Question_ID: qID,
			Activity_By: getIdentity()
		},
	});
}

export function getAnswersWithSkip(qID) {
	return http.get(apiEndpoint + prefix + 'getAnswersWithSkip', {
		params: {
			Question_ID: qID,
			Activity_By: getIdentity()
		},
	});
}

export function getAvailableInstitutions(pID) {
	//console.log('getIdentity', getIdentity())
	return http.get(apiEndpoint + prefix + 'getAvailableInstitutions', {
		params: {
			Project_ID: pID,
			Activity_By: getIdentity()
		},
	});
}

export function updateQuestion(qTxt, qAnswers, state) {
	return http.post(apiEndpoint + prefix + 'updateQuestion', {
		Widget_ID: state.Widget_ID,
		Question_ID: state.Question_ID,
		Question_Type_ID: state.Question_Type_ID,
		Question_Text: qTxt,
		Description: state.Description,
		Response_Required: state.Response_Required,
		Indicate_Response: state.Indicate_Response,
		Align_Horizontal: state.Align_Horizontal,
		Question_Answers: qAnswers,
		Allow_Multiple_Selection: state.Allow_Multiple_Selection,
		Custom_Render: state.Custom_Render,
		Activity_By: getIdentity(),
	});
}

export function updateQuestionAnswers(qID, answers) {
	return http.post(apiEndpoint + prefix + 'updateQuestionO', {
		Question_ID: qID,
		Question_Answers: answers,
		Activity_By: getIdentity(),
	});
}

export function updateMatrix(wID, state) {
	return http.post(apiEndpoint + prefix + 'updateMatrix', {
		Widget_ID: wID,
		Question_ID: state.Question_ID,
		Question_Text: state.Question_Text,
		Description: state.Description,
		Response_Required: state.Response_Required,
		Indicate_Response: state.Indicate_Response,
		Align_Horizontal: state.Align_Horizontal,
		Question_Type_ID: state.Question_Type_ID,
		Question_Answers: state.Question_Answers,
		Matrix_Questions: state.Matrix_Questions,
		Matrix_Answers: state.Matrix_Answers,
		Allow_Multiple_Selection: state.Allow_Multiple_Selection,
		Activity_By: getIdentity(),
	});
}

export function removeQuestion(wID, qID) {
	return http.post(apiEndpoint + prefix + 'removeQuestion', {
		Widget_ID: wID,
		Question_ID: qID,
		Activity_By: getIdentity(),
	});
}

export function removeAnswer(ansID) {
	return http.post(apiEndpoint + prefix + 'removeAnswer', {
		Answer_ID: ansID,
		Activity_By: getIdentity(),
	});
}

export function getSkipOptions(wID) {
	return http.get(apiEndpoint + prefix + 'getSkipOptions', {
		params: {
			Widget_ID: wID,
			Activity_By: getIdentity()
		},
	});
}

export function getIdentifier(wID) {
	return http.get(apiEndpoint + prefix + 'getIdentifier', {
		params: {
			Widget_ID: wID,
			Activity_By: getIdentity()
		},
	});
}

export function generateIdentifierIDSysGenerated(params) {
	return http.post(apiEndpoint + prefix + 'generateCustomIdentifierID', { 
		DataSource_ID: params['dataSourceID'], 
		SP_Selected: params['storedProcedureSelected'], 
		Institution_Code: params['institutionCode'],
		Activity_By: getIdentity()
	 });
}

export function updateIdentifier(state) {

	return http.post(apiEndpoint + prefix + 'updateIdentifier', {
		Widget_ID: state.Widget_ID,
		Identifier_ID:state.Identifier_ID,
		Identifier_Text:state.Identifier_Text,
		Description:state.Description,
		System_Generated:state.System_Generated,
		Identifier_Format:state.Identifier_Format,
		DataSource_ID:state.DataSource_ID,
		ResultSource_Content:state.ResultSource_Content,
		Activity_By: getIdentity(),
	});
}

export function removeForm(Form_ID) {
	return http.post(apiEndpoint + prefix + 'removeForm', {
		Form_ID: Form_ID,
		Activity_By: getIdentity(),
	});
}

export function cloneForm(Project_ID, Form_ID, new_Form_name) {
	return http.post(apiEndpoint + prefix + 'cloneForm', {
		Destination_Project: Project_ID,
		Form_ID: Form_ID,
		New_Form_Name: new_Form_name,
		Activity_By: getIdentity(),
	});
}

export function getDT(wID) {
	return http.get(apiEndpoint + prefix + 'widgetDT', {
		params: {
			Widget_ID: wID,
			Activity_By: getIdentity(),
		},
	});
}

export function getResultSourceTypes() {
	return http.get(apiEndpoint + prefix + 'getResultSourceTypes', { params: { Activity_By: getIdentity() } });
}

export function getDisplayEditInfoDSColumns(state, mode) {
	//console.log('getDisplayEditInfoDSColumns',state, mode)
	return http.post(apiEndpoint + prefix + 'getDisplayEditInfoDSColumns', {
		Connection_String: state.connStr,
		ResultSource_ID: parseInt(state.ResultSource_ID),
		ResultSource_Content: state.ResultSource_Content,
		mode: mode,
		PrimaryKey: (state.isSPParameterized && mode === 'viewer') ? state.PrimaryKey : null,
		Activity_By: getIdentity()
	});
}

export function getDisplayEditInfo(wid){
	return http.post(apiEndpoint + prefix + 'getDisplayEditInfo', { 
		Widget_ID:wid,
		Activity_By: getIdentity(),
	 });
}

export function saveDisplayEditInfo(state) {
	//console.log('state', state)
	return http.post(apiEndpoint + prefix + 'saveDisplayEditInfo', {
		Widget_ID: state.Widget_ID,
		Form_ID: parseInt(state.Form_ID),
		DEI_ID: state.DEI_ID,
		Display_Name: state.Display_Name,
		DataSource_ID: parseInt(state.DataSource_ID),
		ResultSource_ID: state.ResultSource_ID,
		ResultSource_Content: state.ResultSource_Content,
		isSPParameterized: state.isSPParameterized,
		Columns: state.displayColumns,
		Activity_By: getIdentity(),
	});
}

export function toFindColumns(rstid, content, conn, parameters, infoMode = false) {
	return http.post(apiEndpoint + prefix + 'findColumns', {
		ResultSource_ID: rstid,
		ResultSource_Content: content,
		Connection_String: conn,
		Parameters: parameters,
		InfoMode: infoMode,
		Activity_By: getIdentity()
	});
}

export function saveDT(state) {
	return http.post(apiEndpoint + prefix + 'saveDT', {
		DT_ID: state.DT_ID,
		Widget_ID: state.Widget_ID,
		DataSource_ID: state.DataSource_ID,
		ResultSource_ID: state.ResultSource_ID,
		ResultSource_Content: state.ResultSource_Content,
		Action_ID: state.Action_ID || null,
		Action_Form_ID: state.Action_Form_ID || null,
		Display_Name: state.Display_Name,
		Columns: state.Columns || [],
		Parameters: state.Parameters && state.Parameters.length > 0 ? state.Parameters : null,
		WithinRow: state.WithinRow ? state.WithinRow : null,
		EnableServerSidePaging : state.enableServerSidePaging ? state.enableServerSidePaging : null,
		EnableDownloadDT : state.enableDownloadDT ? state.enableDownloadDT : null,
		EnablePrintDT : state.enablePrintDT ? state.enablePrintDT : null,
		EnableFilterDT : state.enableFilterDT ? state.enableFilterDT : null,
		Widget_Color: state.colorSwitch && state.bucketColor ? state.bucketColor : '#0061F2',
		Activity_By: getIdentity(),
	});
}

export function saveDTParameters(Form_ID, Widget_ID, DT_ID, Parameters) {
	return http.post(apiEndpoint + prefix + 'saveDTParameters', {
		Form_ID,
		Widget_ID,
		DT_ID,
		Parameters,
		Activity_By: getIdentity(),
	});
}

export function getSPV(rstid, conn) {
	return http.post(apiEndpoint + prefix + 'findSPV', {
		ResultSource_ID: rstid,
		Connection_String: conn,
		Activity_By: getIdentity()
	});
}

export function findParameters(content, conn) {
	return http.post(apiEndpoint + prefix + 'findParameters', {
		ResultSource_Content: content,
		Connection_String: conn,
		Activity_By: getIdentity()
	});
}

export function loadDT({ wID, Parameters_Set, DTChange }) {
	//console.log('Parameters_Set', Parameters_Set)
	return http.get(apiEndpoint + prefix + 'loadDT', {
		params: {
			Widget_ID: wID,
			Parameters_Set,
			DTChange,
			Activity_By: getIdentity()
		},
	});
}

export function getRowOptions(fID) {
	return http.get(apiEndpoint + prefix + 'getRowOptions', {
		params: {
			Form_ID: fID,
			Activity_By: getIdentity()
		},
	});
}

export function getRowColumns(wID) {
	return http.get(apiEndpoint + prefix + 'getRowColumns', {
		params: {
			Widget_ID: wID,
			Activity_By: getIdentity()
		},
	});
}

export function saveRow(state) {
	return http.post(apiEndpoint + prefix + 'saveRow', {
		Widget_ID: state.Widget_ID,
		Columns: state.Columns,
		Activity_By: getIdentity(),
	});
}

export function loadInfo(wID, Inst_ID) {
	return http.get(apiEndpoint + prefix + 'loadInfo', {
		params: {
			Widget_ID: wID,
			Institution_ID: parseInt(Inst_ID) || null,
			Activity_By: getIdentity()
		},
	});
}

export function getRandomizedResult(Primary_Key, flag) {
	//console.log('API (Primary_Key, flag)', Primary_Key, flag);
	return http.post(apiEndpoint + prefix + 'getRandomizedResult', {
		Primary_Key: parseInt(Primary_Key),
		flag: flag,
		Activity_By: getIdentity(),
	});
}

export function saveResponse(pID, fID, Primary_Key, Form_SecondaryIDValue, Responses, source) {
	return http.post(apiEndpoint + prefix + 'saveResponse', {
		Project_ID: pID,
		Form_ID: fID,
		Primary_Key: Primary_Key,
		Secondary_key: Form_SecondaryIDValue,
		Responses: Responses,
		source: source,
		Activity_By: getIdentity(),
	});
}

export function getResponse(pk, pID, qID) {
	return http.get(apiEndpoint + prefix + 'getResponse', {
		params: {
			Primary_Key: pk,
			Project_ID: pID,
			Question_ID: qID,
			Activity_By: getIdentity()
		},
	});
}

export function getFormData(pk, fID, fBehaviorOnLoad, skName, skVal) {
	return http.post(apiEndpoint + prefix + preloadQAFormEndpoint, {
		Primary_Key: pk,
		Form_ID: fID,
		Form_BehaviorOnLoad: fBehaviorOnLoad,
		Secondary_Key_Name: skName,
		Secondary_Key_Value: skVal,
		Activity_By: getIdentity()
	});
}